package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_supplier_data_di_SupplierModule : Module get() = module {
	single() { _ -> com.essntl.features.supplier.data.repository.SupplierRepositoryImpl(supabase=get()) } bind(com.essntl.features.supplier.domain.repository.SupplierRepository::class)
	single() { _ -> com.essntl.features.supplier.data.supabase.SupplierSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.supplier.data.supabase.SupplierSupabaseDataSource::class)
}
public val com.essntl.features.supplier.data.di.SupplierModule.module : org.koin.core.module.Module get() = com_essntl_features_supplier_data_di_SupplierModule
